module.exports = __webpack_public_path__ + "static/media/atlassian.6b7a1ebf.png";